import React, { useState } from "react";
import Helmet from "react-helmet";
import { AppName, CleanMessage } from "../../util/app";
import { useQuery } from "react-apollo";
import { GET_ACTIVE_APPOINTMENT } from "../../queries/appointment.query";
import { toast } from "react-toastify";
import LoadingSpinner from "../../partials/loading";
import ActiveList from "./partials/ActiveList";
import { EventEmitter } from "../../event/EventEmitter";
import { EVENT_TARGET } from "../../event/model";

const ActiveAppointment = () => {
    const [items, setItems] = useState([]);

    const { loading, refetch } = useQuery(GET_ACTIVE_APPOINTMENT, {
        onError: (e) => toast.error(CleanMessage(e.message)),
        onCompleted: (d) => {
            setItems(d.GetActiveAppointments.docs);
        },
    });

    const title = "Active Appointment";
    EventEmitter.subscribe(EVENT_TARGET.APPOINTMENT, () => refetch());
    return (
        <>
            <Helmet>
                <title>
                    {title} | {AppName}
                </title>
            </Helmet>

            <div className="card">
                <div className="card-head">
                    <header>{title}</header>
                </div>
                <div className="card-body" style={{ minHeight: "420px" }}>
                    <LoadingSpinner loading={loading} />
                    <ActiveList items={items} />
                </div>
            </div>

            <button title="Print" onClick={() => window.print()} className="mdl-button mdl-js-button fab mdl-button--fab mdl-js-ripple-effect mdl-button--colored">
                <i className="material-icons text-white">print</i>
            </button>
        </>
    );
};

export default ActiveAppointment;
